export const DashedCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle
        cx="7"
        cy="7"
        r="6.5"
        stroke="black"
        strokeOpacity="0.85"
        strokeDasharray="2 2"
      />
    </svg>
  );
};
